import { MyProfilePage } from "@/components/profile/MyProfilePage";

export const Home = () => {
  return <MyProfilePage />;
};
